import { useQuery } from "@tanstack/react-query";
import { getSubscriptionProducts } from "helpers/subscription";
import { StripeProducts } from "../types";

/**
 * Hook to fetch and cache Stripe subscription products.
 *
 * @returns Sorted Stripe products
 */
export const useSubscriptionProducts = () => {
  const query = useQuery<StripeProducts>(
    ["subscription-products"],
    getSubscriptionProducts,
    {
      staleTime: Infinity, // Products rarely change during a session
    }
  );

  return {
    ...query,
    products: query.data,
    productsLoading: query.isLoading,
  };
};
